import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/Rx';
import { UserData } from './local/user-data';
import { Observable } from 'rxjs/Observable';

import { IonicAngularProvider } from './ionic-angular/ionic-angular';

@Injectable()
export class HttpClient {

    public dismiss: any;
    private dismissObserver: any;

    constructor(private http: Http,
        public IA: IonicAngularProvider, 
        private userData: UserData) {

        this.dismissObserver = null;
        this.dismiss = Observable.create(observer => {
            this.dismissObserver = observer;
        });
    }

    get(url, typeHeaders: Number = 0) {

        return new Promise((resolve, reject) => {

            let headers = new Headers();
            this.getHeaders(headers, typeHeaders);
            return this.http.get(url, {
                headers: headers
            })
            .timeout(30*1000)
            .map(res => res.json())
            .subscribe(data => {

                //console.log(data);
                return resolve({ status: 'success', data: data});
                //return resolve(data)
            },
            err => {
                console.log(err);
                let result = {
                    status: "error",
                    popRoot: false,
                    message: "Error de conexión a internet"
                }

                try {
                    let error = err.json();
                    if(error.error_description) {
                        result.message = error.error_description;
                    }

                    if(error.description) {
                        result.message = error.description;
                    }

                    if(result.message) {
                        this.IA.toast(result.message);
                    }
                } catch(e) {
                }
                //Check if the error is Unauthorized, and set the login view by a observer 
                if (err.status == 401) {
                    //this.userData.userToken = null;
                    //this.userData.user = null;
                    if(this.dismissObserver){
                        this.dismissObserver.next(true);                        
                    }
                    resolve(false);
                } else { resolve(result); }
                
                //return resolve(err);
            });
        }).catch((err) => {
            throw err;
        });
    }


    post(url, data, typeHeaders: Number = 0) {
        return new Promise((resolve, reject) => {

            let headers = new Headers();
            this.getHeaders(headers, typeHeaders);
            this.http.post(url, data, {
                headers: headers
            })
            .timeout(30*1000)
            .map(res => res.json())
            .subscribe(data => {
            return resolve({ status: 'success', data: data});
            },
            err => {
                //alert(JSON.stringify(err));
                let result = {
                    status: "error",
                    popRoot: false,
                    message: "Error de conexión a internet"
                }

                try{
                    let error = err.json();
                    if(error.error_description) {
                        result.message = error.error_description;
                    }

                    if(error.description) {
                        result.message = error.description;
                    }

                    if(result.message) {
                        this.IA.toast(result.message);
                    }
                } catch(e) {
                }

                //Check if the error is Unauthorized, and set the login view by a observer 
                if (err.status == 401) {
                    //this.userData.userToken = null;
                    //this.userData.user = null;
                    if(this.dismissObserver){
                        this.dismissObserver.next(true);                        
                    }
                    resolve(false);
                } else { resolve(result); }
            });
        }).catch((err) => {
            throw err;
        });
    }

    getHeaders(headers, type) {
      if (!headers) {
        headers = new Headers();
      }

      if(type == 1){
          headers.append('Authorization',`Bearer ${this.userData.userToken}`);
      }
      /* headers del proyecto*/ 
      
    }
}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/http-client.ts